/**
 * Support offer
 *
 * A button that opens the support chat, put next to a form whose refusal the player
 * cannot get past alone (the server sends `support` with the refusal: reason, party id,
 * button label, message draft). Drawn only when the chat is on - window.bbSupport is
 * declared by the LiveChat module, which is not loaded at all when the chat is off - so
 * without it the player keeps the refusal's own text and no dead button.
 *
 * @package betbeast
 */

/**
 * Show (or refresh) the offer just before `anchor`, usually the form's submit button.
 *
 * @param {HTMLElement} anchor  Element the offer is placed before.
 * @param {Object}      support The refusal's `support`: reason, party_id, button, draft.
 * @param {string}      [text]  The refusal's message, kept beside the button once the toast is gone.
 * @returns {boolean} Whether the offer was shown.
 */
export function offerSupport(anchor, support, text) {
    const chat = window.bbSupport;
    if (!anchor || !anchor.parentNode || !support || !support.reason || !chat || typeof chat.open !== 'function') {
        return false;
    }

    let box = anchor.parentNode.querySelector('.support-offer');
    if (!box) {
        box = document.createElement('div');
        box.className = 'support-offer';
        anchor.parentNode.insertBefore(box, anchor);
    }
    box.textContent = '';

    if (text) {
        const line = document.createElement('p');
        line.className = 'support-offer__text';
        line.textContent = text;
        box.appendChild(line);
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button support-offer__button';
    button.textContent = support.button || 'Contact support';
    button.addEventListener('click', function () {
        chat.open(support.reason, support.draft || '', support.party_id || '');
    });
    box.appendChild(button);

    return true;
}
